import { isAxiosError } from "axios";
import { ErrorResponse } from "../types";

export function getErrorMessage(e: unknown) {
  if (isAxiosError<ErrorResponse>(e) && e.response) {
    return e.response.data.errorDescription;
  }
  return "Произошла непредвиденная ошибка.";
}
